



































































import { PublicCourseDetails } from '@/jbi-shared/dto/jtms-public-course.dtos';
import { CourseStatus } from '@/jbi-shared/types/jtms.types';
import BaseButton from '@/jbi-shared/vue-components/BaseButton.vue';
import BaseNumberStepper from '@/jbi-shared/vue-components/BaseNumberStepper.vue';
import { RootState } from '@/store/store';
import { Vue, Component, Emit, Model } from 'vue-property-decorator';
import { Getter, State } from 'vuex-class';

@Component({
  components: {
    BaseButton,
    BaseNumberStepper
  }
})
export default class CallToActionCard extends Vue {
  @Model('input', { type: Number, default: 1 }) readonly value!: number;

  @Getter('course/isFreeCourse')
  isFreeCourse!: boolean;

  @Getter('course/isGroupRegistrationEnabled')
  groupRegistrationEnabled!: boolean;

  @Getter('course/hasCourseModules')
  hasCourseModules!: boolean;

  @Getter('course/hasMultipleCoursePackages')
  hasMultipleCoursePackages!: boolean;

  @State(({ course }: RootState) => course.publicCourseState.courseDetails)
  publicCourseDetails!: PublicCourseDetails;

  get disableStepper(): boolean {
    return this.isFreeCourse && this.hasCourseModules;
  }

  // Only display remaining seat count on this component if
  // - Course is free
  // - Group Registration Enabled
  // - No Course Modules (Just course package as overall price for the entire course)
  get enableSeatsLeft(): boolean {
    return (
      this.isFreeCourse &&
      this.groupRegistrationEnabled &&
      !this.hasCourseModules
    );
  }

  get maxValue(): number {
    if (!this.publicCourseDetails.courseSize) {
      return 0;
    }

    // No course modules = no course packages, and group registration is enabled,
    // stepper max value is set to overall course size
    if (!this.hasCourseModules && this.groupRegistrationEnabled) {
      return +this.publicCourseDetails.courseSize;
    }

    // No course modules = no course packages, and individual registration,
    // stepper max value is set to just 1
    if (!this.hasCourseModules && !this.groupRegistrationEnabled) {
      return 1;
    }

    return 0;
  }

  get remaingSeats(): number {
    if (!this.publicCourseDetails) {
      1;
    }

    return this.publicCourseDetails.courseSize! - this.value;
  }

  get shouldDisableActionButton(): boolean {
    const isCourseStatusValid: boolean =
      this.publicCourseDetails.status === CourseStatus.COMPLETED ||
      this.publicCourseDetails.status === CourseStatus.IN_PROGRESS ||
      this.publicCourseDetails.status === CourseStatus.CANCELLED;

    // JAAS-2803-TODO:
    // - `courseSoldOut` should be adjusted based on SEAT AVAILABILITY, defaults to false for now
    const courseSoldOut: boolean = false;
    const registrationClosed: boolean = !this.publicCourseDetails
      .openForRegistration;

    return isCourseStatusValid || courseSoldOut || registrationClosed;
  }

  // Returns the specific reason why the action button is disabled
  // Priority Order: Registration Closed > Status > Sold Out
  get actionButtonTooltip(): string {
    const status = this.publicCourseDetails.status;

    // 1. Check Registration Window (Highest Priority)
    if (!this.publicCourseDetails.openForRegistration) {
      return 'Registration for this course is currently closed.';
    }

    // 2. Check Course Status
    if (status === CourseStatus.CANCELLED) {
      return 'This course has been cancelled.';
    }
    if (status === CourseStatus.COMPLETED) {
      return 'This course has already concluded.';
    }
    if (status === CourseStatus.IN_PROGRESS) {
      return 'This course is currently in progress.';
    }

    // 3. Check Sold Out
    // JAAS-2803-TODO: Adjust based on SEAT AVAILABILITY
    const courseSoldOut: boolean = false;
    if (courseSoldOut) {
      return 'This course is sold out.';
    }

    return '';
  }

  get priceRange(): string {
    // Declared as const for better readability
    const courseIsNotFreeButHasNoCoursePackages: boolean =
      !this.publicCourseDetails.coursePackages && !this.isFreeCourse;
    if (
      courseIsNotFreeButHasNoCoursePackages ||
      !this.publicCourseDetails.minPrice ||
      !this.publicCourseDetails.maxPrice
    ) {
      return 'AUD 0';
    }

    const minPrice: number = Number(this.publicCourseDetails.minPrice);
    const maxPrice: number = Number(this.publicCourseDetails.maxPrice);

    // If min and max price is different, it implies that a course has multiple packages
    // with varying prices
    if (minPrice != maxPrice) {
      return `From AUD ${Number(this.publicCourseDetails.minPrice)} - ${Number(
        this.publicCourseDetails.maxPrice
      )}`;
    }

    return `AUD ${Number(this.publicCourseDetails.minPrice)}`;
  }

  get buttonLabel(): string {
    if (this.groupRegistrationEnabled) {
      return 'Get Tickets';
    }

    return 'Get a Ticket';
  }

  @Emit('input')
  onValueChange(val: number) {
    console.log(val);
    return val;
  }

  @Emit('click')
  emitEvent() {
    return;
  }
}
